module.exports = __webpack_public_path__ + "static/media/completed.ac8c48b1.svg";